const envUrl = (value: string | undefined) => value?.trim() || undefined;

export const PLATFORM_URLS = {
  admin: envUrl(import.meta.env.VITE_ADMIN_URL) || '/admin',
  school: envUrl(import.meta.env.VITE_SCHOOL_URL) || '/school',
  company: envUrl(import.meta.env.VITE_COMPANY_URL) || '/company',
  homePc: envUrl(import.meta.env.VITE_HOME_PC_URL) || '/',
};
